module.exports = __webpack_public_path__ + "img/10.56f705fa.png";